export const CHECK_DECODER_MONITOR_TIME_DELAY = 60_000;
export const FETCH_ENCODERS_TIME_DELAY = 120_000;
export const TIMEZONE_CARD_TIME_DELAY = 60_000;
export const ALL_VERSIONS = 'All Versions';
